import { englischNormalisieren } from '../englisch';
import type { KatalogAuszug, KatalogKnoten, StandardKatalog } from '../typen';
import baum from './baum.json';
import auszug from './kernauszug.generated.json';
import zuordnung from './abschnittZuordnung.json';
import englisch from './englisch.generated.json';

/**
 * Der Standard-Katalog im Bundle (statisch): Baum der Torte, der Textauszug
 * der Einträge, auf die der Baum verweist, und die Zuordnung Abschnitt →
 * Kategorie. Die Torte geht damit ohne Nachladen; der Gesamtkatalog für die
 * Suche kommt lazy (laden.ts).
 *
 * `baum.json` pflegt das Review (scripts/mangelKatalog/review-anwenden.ts),
 * `kernauszug.generated.json` erzeugt scripts/mangelKatalog/kernauszug-erzeugen.ts
 * — nie von Hand ändern. Der Inhaltstest (inhalt.test.ts) hält beides zusammen.
 *
 * Englische Fassung (28.09.): `englisch.generated.json` (Knoten-Beschriftungen
 * und englischer Auszug, erzeugt von scripts/mangelKatalog/englisch-erzeugen.ts
 * aus den Übersetzungen in scripts/mangelKatalog/daten/englisch). Liegt dort
 * nur `{ "knoten": {}, "auszug": {} }`, gilt auch bei 'en' der deutsche Text.
 */

/** Steigt mit jeder inhaltlichen Änderung am Standard (Merker „neu“ im Admin). */
export const KATALOG_VERSION: number = (baum as { version: number }).version;

/**
 * Knoten-IDs, die es einmal gab und die nie wieder vergeben werden dürfen:
 * gespeicherte Mängel tragen sie als `katalogKey`. Beim Entfernen eines
 * Standardknotens hier eintragen.
 */
export const AUSGEMUSTERTE_IDS: readonly string[] = Object.freeze([]);

export const STANDARD_KATALOG: StandardKatalog = Object.freeze({
    version: KATALOG_VERSION,
    knoten: (baum as unknown as { knoten: KatalogKnoten[] }).knoten,
    auszug: auszug as unknown as Record<string, KatalogAuszug>,
    abschnittZuordnung: zuordnung as unknown as Record<string, string>,
    englisch: englischNormalisieren(englisch),
});
